import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
// import { persistor, store } from './store';
import { Toaster } from 'react-hot-toast';
// import SessionManager from './components/sessionManager/SessionManager';
import { ThemeContextProvider } from './context/ThemeContext';
import './i18n';
import { setAppConfig } from './config/appConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));


const renderApp = async () => {
  const { default: App } = await import('./App.js');
  const { default: SessionManager } = await import('./components/sessionManager/SessionManager');
  const { persistor, store } = await import('./store');

  root.render(
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <ThemeContextProvider>
            <Suspense fallback={<div>Loading translations...</div>}>
              <Toaster position="top-right" reverseOrder={false} toastOptions={{ duration: 4000 }} />
              <SessionManager />
              <App />
            </Suspense>
          </ThemeContextProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

fetch('/config.json')
  .then((res) => res.ok ? res.json() : Promise.reject(new Error('Failed to load config.json')))
  .then((cfg) => {
    console.log('config.json loaded successfully', cfg);
    setAppConfig(cfg);
    renderApp();
  })
  .catch((e) => {
    setAppConfig({});
    renderApp();
  });

reportWebVitals();
